import React from 'react';
import { InfoCircleIcon, EmailIcon } from '../icons';

type NotAFitReason = 'age' | 'location' | 'custom';

type NotAFitProps = {
  reason?: NotAFitReason;
  title?: string;
  messages?: string[];
};

const contentByReason: Record<NotAFitReason, { title: string; messages: string[] }> = {
  age: {
    title: "We're Sorry",
    messages: [
      "Guides Collective services are only available to individuals who are 21 years of age or older. This requirement exists to ensure the safety and well-being of all participants.",
      "If you believe you received this message in error, or if you have any questions, please feel free to reach out to us."
    ]
  },
  location: {
    title: "Not Available in Your Area",
    messages: [
      "Unfortunately, Guides Collective services are not currently available in your location. We're working to expand our reach and hope to be able to serve your area in the future.",
      "If you believe you received this message in error, or if you have questions about service availability, please don't hesitate to contact us."
    ]
  },
  custom: {
    title: "We're Sorry",
    messages: ["Please contact support for assistance."]
  }
};

export function NotAFit({ reason = 'age', title, messages }: NotAFitProps) {
  const content = contentByReason[reason];
  const displayTitle = title || content.title;
  const displayMessages = messages || content.messages;

  return (
    <div className="flex h-screen min-h-screen w-full items-stretch overflow-hidden">
      <div className="relative flex h-full w-full flex-1 flex-col bg-white">
        <header className="flex h-16 shrink-0 items-center border-b border-[#FFFCEF]/25 bg-[#2C2731] px-4">
          <div className="w-10" aria-hidden />
          <div className="flex flex-1 justify-center">
            <img src="/gclogo.webp" alt="Guides Collective" className="h-8 w-auto" />
          </div>
          <div className="w-10" aria-hidden />
        </header>

        <main className="flex flex-1 min-h-0 flex-col items-center justify-center gap-6 overflow-y-auto px-6 pb-12 pt-6">
          <div className="flex max-w-md flex-col items-center gap-6 text-center">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#304031]/10">
              <InfoCircleIcon className="h-10 w-10 text-[#304031]" />
            </div>

            <h1 className="font-recoleta text-[32px] font-normal leading-[1.1] text-[#304031]">
              {displayTitle}
            </h1>

            {displayMessages.map((message, index) => (
              <p
                key={index}
                className="font-helvetica text-[15px] leading-relaxed text-[#214D3C]/80"
              >
                {message}
              </p>
            ))}

            <a
              href="mailto:support@guidescollective.org"
              className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#304031]/30 bg-white px-6 py-3 font-helvetica text-base font-medium text-[#304031] transition hover:-translate-y-0.5 hover:border-[#304031]"
            >
              <EmailIcon className="h-5 w-5" />
              Contact Support
            </a>
          </div>
        </main>
      </div>
    </div>
  );
}
